import React, { useEffect, useState } from 'react';
const API_URL = "https://v6d18bgl57.execute-api.us-west-1.amazonaws.com/prod/admin-users";

const UserList = ({ user }) => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;
  
  const formatDate = (timestamp) => {
    if (!timestamp) return '-';
    try {
      const date = new Date(timestamp);
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    } catch {
      return '-';
    }
  };
  
  const fetchUsers = () => {
    const token = user?.signInUserSession?.idToken?.jwtToken;
    if (!token) {
      console.error("No JWT token available");
      return;
    }
    
    fetch(API_URL, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(data => setUsers(data.users || []))
      .catch(err => console.error("Failed to fetch users:", err));
  };
  
  useEffect(() => {
    fetchUsers();
  }, []);
  
  const indexOfLast = currentPage * usersPerPage;
  const indexOfFirst = indexOfLast - usersPerPage;
  const currentUsers = users.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(users.length / usersPerPage);

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>User List ({users.length} total)</h3>
        <button className="btn btn-sm btn-outline-secondary" onClick={fetchUsers}>Refresh</button>
      </div>
      
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th>Email</th>
              <th>Plan</th>
              <th>Archives</th>
              <th>Forever Domain</th>
              <th>Trial Used</th>
              <th>Trial Timestamp</th>
              <th>Signup Time</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentUsers.map(user => (
              <tr key={user.sub}>
                <td>{user.email || '-'}</td>
                <td>
                  <span className={`badge ${
                    user.plan === 'premier' ? 'bg-premier' :
                    user.plan === 'essentials' ? 'bg-primary' : 'bg-secondary'
                  }`}>
                    {user.plan || 'trial'}
                  </span>
                </td>
                <td>
                  {user.plan === 'forever'
                    ? `Forever (${user.forever_archive_count || 0})`
                    : user.archive_count || 0}
                </td>
                <td>{user.plan === 'forever' ? user.forever_domain_locked || '—' : '—'}</td>
                <td>{user.trial_used ? 'Yes' : 'No'}</td>
                <td>{formatDate(user.trial_archive_timestamp)}</td>
                <td>{formatDate(user.signup_time)}</td>
                <td>
                  <button 
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => setSelectedUser(user)}
                  >
                    View Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {totalPages > 1 && (
        <nav>
          <ul className="pagination">
            {[...Array(totalPages)].map((_, i) => (
              <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                  {i + 1}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      )}
      
      {selectedUser && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">User Details: {selectedUser.email}</h5>
                <button className="btn-close" onClick={() => setSelectedUser(null)}></button>
              </div>
              <div className="modal-body">
                <pre>{JSON.stringify(selectedUser, null, 2)}</pre>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserList;
